import React from 'react';
import Loading from '../loading';

import {Container} from './styles';
import {Tooltip} from '@mantine/core';

export interface IconButtonProps {
  onClick?: () => void;
  label?: string;
  variant?: 'filled' | 'clean';
  icon?: React.ReactNode;
  loading?: boolean;
  backgroundColor?: string;
  tooltip?: string;
  color?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  onClick,
  label,
  variant = 'clean',
  icon,
  loading,
  backgroundColor,
  tooltip,
  color,
}) => {
  const getContent = () => {
    if (loading)
      return (
        <Container {...{variant, backgroundColor}}>
          <Loading />
        </Container>
      );

    return (
      <Container
        {...{
          onClick: (e) => {
            if (!onClick) return;
            e.stopPropagation();
            onClick();
          },
          variant,
          backgroundColor,
          color,
        }}
        type="button">
        {icon}
        {label}
      </Container>
    );
  };

  return tooltip ? (
    <Tooltip position="top" label={tooltip}>
      {getContent()}
    </Tooltip>
  ) : (
    getContent()
  );
};

export default IconButton;
